import React, { Component } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Modal,
  ModalBody,
  Button,
  Row,
  Col,
  Collapse,
  Alert,
  UncontrolledCollapse,
  ModalHeader,
} from "reactstrap";
import {
  getGenderLists,
  createKPIAgreegateRequestDataRefreshChart,
  getAllOccupationAndSeniorityValues,
} from "../../../utils/filterKpisData";
import {
  kpiBasedType,
  chartPrivacy,
  hierarchyChangeNotifications,
  dtickFormat,
  returnHierarchyGroup,
  findNodeinHierarchy,
  selectOfficeCheck,
  legendPosition,
  chart_legend_position,
  chartParams,
  renderGenderPronoun,
} from "../../../utils/constants";
import "./../Chart.css";
import Plot from "./../../../utils/customPlotly";
import { isMobile, isChrome, isSafari } from "./../../../utils/deviceInfo";
import OoPopover from "../../../components/UI/Popover/OoPopover";
import moment from "moment";
import isEmpty from "lodash/isEmpty";
import "rc-checkbox/assets/index.css";
import privacyIcon from "./../../../assets/privacy_icon.svg";
import privacyOfficesBelowIcon from "../../../assets/privacy-icon-offices-below.svg";
import lockIcon from "./../../../assets/lock.svg";
import favoritedIcon from "./../../../assets/heartFilled.png";
import warningIcon from "./../../../assets/warning.svg";
import dashboardIcon from "./../../../assets/placeholders/dashboardIcon.svg";
import Select from "react-select";
import axios from "./../../../axios";
import * as url from "./../../../utils/url";
import { deepClone } from "./../../../utils/copyObject";
import AddToGroup from "../../../components/AddToGroup/AddToGroup";
import communityIcon from "./../../../assets/privacy-icon-offices-below.svg";

import size from "lodash/size";
import map from "lodash/map";
import dot from "./../../../assets/dot-icon.png";
import ReactTooltip from "react-tooltip";
import ManualEntryModal from "./ManualEntryModal";
import If from "../../../components/Shared/If";
import ViewChart from "../ViewChart/ViewChart";
import ChartAverageTable from "../ViewChart/ChartAverageTable";
import LockUnlockChartComponent from "../../../components/LockUnlockChart/LockUnlockChartComponent";

class ChartListItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false,
      isOnDashboard: false,
      showDashboardUrl: false,
      commentList: [],
      plotData: [],
      rangeInit: [],
      isPlotInit: false,
      plotlyDTick: this.props.chart.dtickFormat,
      isCommentsShown: false,
      selectedDashboard: null,
      clickedPoint: null,
      showArchiveConfirmationModal: false,
      showUnarchiveConfirmationModal: false,
      showManualEntryAnswersModal: false,
      isGroupModal: false,
      revision: false,
      showLegend: true,
      isDashboardModal: false,
      dashboardOptions: deepClone(this.props.dashboardOptions),
      allOptions: deepClone(this.props.dashboardOptions),
      testOptions: deepClone(this.props.dashboardOptions),
      collapse: true,
      attachedDashboards: [],
      showViewChart: false,
      chart: this.props.chart,
      officeName: this.props.name,
      annotations: [],
    };
    this.plotRef = null;
  }

  toggle = () => {
    const { dropdownOpen } = this.state;
    this.setState({ dropdownOpen: !dropdownOpen });
  };

  toggleLegendShow = () => {
    const { showLegend } = this.state;
    this.setState({ showLegend: !showLegend });
  };

  componentDidMount = () => {
    // let {user, chart }=this.props
    // let{staticHierarchy}=profile.organizationId
    // let{profile}= user
    // // let{dateTime}= profile.organizationId.lastUpdate
    // let {selectedOffice}=chart
    // let office = findNodeinHierarchy(staticHierarchy, selectedOffice.value)
    // let officeName = office.title
    // console.log(officeName)
    // this.setState({officeName})
    // if(chart.lastUpdate && chart.lastUpdate && profile.organizationId
    //     && profile.organizationId.lastUpdate && profile.organizationId.lastUpdate.type=="NEW OFFICE NAMES"
    //     && chart.lastUpdate.dateTime < dateTime
    //   ){
    //       let{staticHierarchy}=profile.organizationId
    //       console.log(staticHierarchy)
    //       let office = findNodeinHierarchy(staticHierarchy, selectedOffice.value)
    //       console.log(office)
    //       let officeName = office.title
    //       this.setState({officeName})
    // } else {
    //   let officeName = chart.selectedOffice && chart.selectedOffice.label?chart.selectedOffice.label :  office ? office.name : ''
    //   this.setState({officeName})
    // }
  };

  componentWillReceiveProps(nextProps) {
    if (
      JSON.stringify(this.props.dashboardOptions) !==
      JSON.stringify(nextProps.dashboardOptions)
    ) {
      this.setState({
        dashboardOptions: deepClone(nextProps.dashboardOptions),
        allOptions: deepClone(nextProps.dashboardOptions),
        testOptions: deepClone(nextProps.dashboardOptions),
      });
    }
  }

  handleExportToPng = id => {
    // console.log(this.plotRef,'---id---', id)
    // this.setState({dropdownOpen : false});
    this.props.onExportAsPng(id, this.plotRef);
  };

  handleArchive = () => {
    const { category, id, isArchived } = this.props;
    if (category === "archive" || isArchived) {
      this.setState({ dropdownOpen: false });
      this.props.onRestoreChart(id);
    } else {
      this.setState(state => ({
        showArchiveConfirmationModal: !state.showArchiveConfirmationModal,
      }));
    }
  };

  archiveChart = id => {
    this.props.onArchive(id);
    this.setState(state => ({
      showArchiveConfirmationModal: !state.showArchiveConfirmationModal,
    }));
  };

  

  handleEdit = () => {
    const { id, category } = this.props;
    const { chart } = this.state;
    if (category === "archive") {
      this.setState({
        showUnarchiveConfirmationModal: true,
      });
    } else {
      this.props.onEdit(id, chart);
    }
  };

  handleRecreate = () => {
    const { id } = this.props;
    this.props.onRecreate(id);
  };

  handleChartPointClick = (a) => {
    const { rawData, kpiType } = this.props;
    if (kpiType === kpiBasedType.surveyBased) {
      this.setState({
        showManualEntryAnswersModal: true,
        clickedPoint: a,
      });
    }

    const annotations_old = [...this.state.annotations];

    const getAvgTenureIfAvailable=(pointData,pointIndex)=>{
      if(pointData && pointIndex>=0){
        if(pointData.data && pointData.data.text && pointData.data.text.length){
          for (const str of pointData.data.text[pointIndex]) {
            if(str.indexOf("Avg Tenure")>=0){
              return ", "+str;
            }
          }
        }
      }
      return "";
    }


    if (a.points && a.points[0] && a.points[0].data) {
      const pointIndex = a.points[0].pointIndex;
      const curveIndex = a.points[0].curveNumber;
      const pointData = a.points[0];

     let annotate_text = `${pointData.text[0]}, ${Math.round(pointData.y *
        100)}% ${getAvgTenureIfAvailable(pointData,pointIndex)}`;

      let annotation = {
        text: annotate_text,
        x: pointData.x,
        y: parseFloat(pointData.y.toFixed(2)),
        borderwidth:1,
        clicktoshow:"onoff"
      };

      annotations_old.push(annotation);

      this.setState({ annotations: annotations_old });

      if (this.props.updateChartPointers) {
        this.props.updateChartPointers(
          this.state.chart._id,
          pointIndex,
          curveIndex
        );
      }
    }
  };

  handleChartPointDoubleClick = (a) => {
    this.setState({ annotations: [] });
    if (this.props.resetChartPointers) {
      this.props.resetChartPointers();
    }
  };

  handlePlotContainerClick = () => {
    this.props.reloadChart(this.props.id);
  };

  // Refresh chart if user click on refrsh chart
  refreshChart = () => {
    const {
      kpiType,
      kpiChartData,
      mappingMaster,
      id,
      chart,
      user,
    } = this.props;
    let { staticHierarchy } = user.profile.organizationId;
    let { selectedOffice } = chart;

    // console.log(this.props, mappingMaster, chart)
    let results = {};
    let kpiRequestData;
    let {
      allOccupationValues,
      allSeniorityValues,
    } = getAllOccupationAndSeniorityValues(mappingMaster.mappingMasterList);
    let KRD = kpiChartData.map(kpi => {
      if (kpiType === kpiBasedType.empDataBased) {
        return createKPIAgreegateRequestDataRefreshChart(
          kpi,
          mappingMaster.mappingMasterList,
          allOccupationValues,
          allSeniorityValues
        );
      } else if (kpiType === kpiBasedType.surveyBased) {
        return { code: kpi.kpiId.code };
      }
    });
    let orgMapping = mappingMaster.mappingMasterList;
    let genderMapping = getGenderLists(orgMapping);
    results = { kpiList: KRD, ...genderMapping, kpiType };
    // console.log(results)
    // results=kpiRequestData
    // console.log(results)
    // let allOfficeKeys={}

    let chartHierarchyVersion =
      chart.hierarchyVersion == null ? false : chart.hierarchyVersion;

    let orgChartHierarchyVersion =
      user.profile.organizationId.hierarchyVersion == null
        ? false
        : user.profile.organizationId.hierarchyVersion;

    // if(orgChartHierarchyVersion==false){
    //   // update org model hierarchy (mostly old users)
    //   results['allOfficeKeys'] =  chart.officeKeyArray==null? returnHierarchyGroup(staticHierarchy, selectedOffice.value):chart.officeKeyArray
    //   results['isUpdate'] = {status: true, org:true, chart:true}

    // } else if (chartHierarchyVersion==false && orgChartHierarchyVersion!==false){
    //   results['allOfficeKeys'] =  chart.officeKeyArray==null? returnHierarchyGroup(staticHierarchy, selectedOffice.value):chart.officeKeyArray
    //   results['isUpdate'] = {status: true, chart:true}

    // } else if ((chartHierarchyVersion && chartHierarchyVersion!==false)!= (orgChartHierarchyVersion && orgChartHierarchyVersion!==false)){
    //   results['allOfficeKeys'] =  returnHierarchyGroup(staticHierarchy, selectedOffice.value)
    //   results['isUpdate'] = {status: true, chart:true}
    // }
    // console.log(chart)
    // officeHierarchyPath
    if (selectedOffice && selectedOffice.value) {
      if (chart && chart.kpiType != "SURVEY_BASED") {
        results["allOfficeKeys"] = returnHierarchyGroup(
          staticHierarchy,
          selectedOffice.value
        );
      }
      results["officeKey"] = selectedOffice.value;
      results["missingSelectedOffice"] = false;
    } else {
      let nameArr = chart.officeId.officeHierarchyPath.split("#");
      let name = nameArr[nameArr.length - 1];
      let office = staticHierarchy.filter(e => e.id === name)[0];

      if (chart && chart.kpiType != "SURVEY_BASED") {
        results["allOfficeKeys"] = returnHierarchyGroup(
          staticHierarchy,
          office.officeKey
        );
      }

      results["officeKey"] = office.officeKey;
      results["missingSelectedOffice"] = true;
      results["officeData"] = office;
    }
    results["isUpdate"] = { status: true, chart: true };
    // console.log(results)

    // if((chart.hierarchyVersion!=null && chart.hierarchyVersion) !== (user.profile.organizationId.hierarchyVersion!=null && user.profile.organizationId.hierarchyVersion)){
    //   results.hierarchyVersion = user.profile.organizationId.hierarchyVersion
    //   if(selectedOffice && selectedOffice.value){
    //     results.allOfficeKeys =  returnHierarchyGroup(staticHierarchy, selectedOffice.value)
    //    } else if(officeId && officeId.officeKey){
    //     results.allOfficeKeys =  returnHierarchyGroup(staticHierarchy, officeId.officeKey)
    //    }
    //    results.isUpdate = true
    // } else {
    //   if(chart.officeKeyArray && Array.isArray(chart.officeKeyArray)){
    //     results.allOfficeKeys= chart.officeKeyArray
    //   } else {
    //     results.allOfficeKeys =  returnHierarchyGroup(staticHierarchy, officeId.officeKey)
    //     results.isUpdate = true
    //   }
    // }

    // console.log(this.props)
    // console.log(results, id)
    results["_id"] = id;
    // results['allOfficeKeys'] =  returnHierarchyGroup(staticHierarchy, selectedOffice.value)
    results["isUpdate"] = { status: true, chart: true };
    // console.log(results)
    this.props.onRefreshChartClick(results);
    // this.props.onRefreshChartClick(kpiRequestData, id, allOfficeKeys);
  };

  toggleLegend = () => {
    const { collapse } = this.state;
    this.setState({ collapse: !collapse });
  };
  // Method will return Legend Description

  showLegendReference = id => {
    const { kpiData, benchmarkArray, benchmarkData, kpiChartData } = this.props;
    const dataMap = map(kpiChartData, (eachKPI, index) => {
      if (size(eachKPI.score) > 0) {
        return {
          KPIKey: index,
          KPIDescription: kpiData[index].description,
        };
      } else {
        return null;
      }
    });
    const filterActualDataExistKPI = dataMap.filter(obj => obj);
    const { collapse } = this.state;
    return (
      <div>
        <div>
          <div onClick={this.toggleLegend} className="legendsButton">
            Legend Details{" "}
            <i
              className="review-mapping-row flaticon-down"
              style={{ marginLeft: "90px", marginTop: "-18px" }}
            ></i>
          </div>
        </div>
        <Collapse isOpen={collapse}>
          {
            <div className="legendsDiv">
              {filterActualDataExistKPI.map((eachDataKPI, index) => (
                <div className="legendsTitle" key={index}>
                  {eachDataKPI.KPIDescription}
                </div>
              ))}
              {!isEmpty(benchmarkArray.score) ? (
                <div className="legendsTitle">{benchmarkData.description}</div>
              ) : null}
            </div>
          }
        </Collapse>
      </div>
    );
  };

  changeDtickFormat = val => {
    // console.log('val----', val)
    return val;
    // this.setState({plotDtick:})
  };

  onPlotlyUpdate = plot => {
    let { rangeInit } = this.state;
    if (plot && plot.layout && plot.layout.xaxis) {
      let { range } = plot.layout.xaxis;
      if (
        rangeInit &&
        rangeInit != null &&
        rangeInit.length > 1 &&
        range.length > 1
      ) {
        let plotlyDTick = dtickFormat(range[0], range[1]);
        let pTick2 = dtickFormat(rangeInit[0], rangeInit[1]);
        // console.log(pTick2, '----', plotlyDTick)
        if (pTick2 != plotlyDTick) {
          this.setState({ rangeInit: range, plotlyDTick });
        }
      } else {
        this.setState({ rangeInit: range });
      }
    }
  };

  isDashboardChart = () => {
    let { organizationId } = this.props.user.profile;
    let { chart } = this.props;
    let { allOptions } = this.state;
    let db_options = deepClone(allOptions);

    // console.log(chart.name, "----Chart NAME---", chart._id);

    let that = this;
    let payload = {
      organizationId: organizationId._id,
      chartId: chart._id,
    };
    axios
      .post(url.getChartDashboards, payload)
      .then(response => {
        let attachedDashboards = response.data.data;
        let checked_arr = deepClone(db_options);
        // console.log("checked---", checked_arr);
        // console.log("attachedDashboards --- ", attachedDashboards);
        if (attachedDashboards && attachedDashboards.length > 0) {
          checked_arr = checked_arr.map(e => {
            if (
              attachedDashboards.indexOf(e.id) > -1 &&
              attachedDashboards.length > 0
            ) {
              e.name = (
                <option className="label addChartDashboardOption" disabled>
                  {e.name} (added)
                </option>
              );
            }
            return e;
          });
        }
        that.setState({
          attachedDashboards,
          isDashboardModal: true,
          dashboardOptions: checked_arr,
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  addToDashboard = () => {
    let { chart, user } = this.props;
    let { selectedDashboard, dashboardOptions } = this.state,
      insert_charts = {};

    let res = {
      ...chart,
      col_size: 6,
      goals: [],
      comments: [],
      isArchive: {},
      chartId: chart._id,
      dashboardId: selectedDashboard.id,
      _id: null,
      lastUpdate: {},
      // createdDate: new Date(),
      originalChartOwner: chart.createdBy,
      createdBy: user.profile._id,
      dashboardDate: new Date(),
      lockedDate: this.state.chart.lockedDate,
    };
    delete res._id;

    insert_charts = {
      dashboardId: selectedDashboard.id,
      add_charts: res,
    };

    // insert_charts.push(res)
    let that = this;
    axios
      .post(url.insertCharts, { insert_charts })
      .then(response => {
        if (dashboardOptions && dashboardOptions.length > 0) {
          dashboardOptions = dashboardOptions.map(e => {
            if (e.id === selectedDashboard.id) {
              e.name = (
                <option className="label addChartDashboardOption" disabled>
                  {e.name} (added)
                </option>
              );
            }
            return e;
          });
        }
        // }   dashboardOptions

        that.setState({
          chart: {
            ...chart,
            dashboard_array: [selectedDashboard.id, chart.dashboard_array],
            dashboardCount: chart.dashboardCount + 1,
            lockedDate: this.state.chart.lockedDate,
          },
          //  ,isDashboardModal:false
          dashboardOptions,
          showDashboardUrl: true,
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  onSelectDashboard = selectedDashboard => {
    if (selectedDashboard && selectedDashboard != null) {
      this.setState({ selectedDashboard });
    }
  };

  navigateToChart = value => {
    if (value == "isChartNotesDisplay") {
      this.setState({ showViewChart: true, isChartNotesDisplay: true });
    } else {
      this.setState({ showViewChart: true, chart: value });
    }
  };

  closeViewChartModal = chart => {
    this.setState({
      showViewChart: false,
      chart: { ...this.state.chart, lockedDate: chart.lockedDate },
    });
  };

  goToDashboard = dashboardId => {
    let url = `/home/dashboard/${this.props.user.profile.organizationId._id}/view/${dashboardId.id}`;
    // this.props.history.push(url)
    this.props.goToDashboard(url);
  };

  closeGroupModal = () => {
    this.setState({ isGroupModal: false });
  };

  handleLockToggleChange = e => {
    const checked = e.target.checked;

    axios
      .post(url.lockUnlockChart, {
        lockedDate: checked ? new Date() : null,
        chartId: this.state.chart._id,
      })
      .then(({ data }) => {
        if (checked) {
          this.setState({
            chart: { ...this.state.chart, lockedDate: new Date() },
          });
        } else {
          this.setState({ chart: { ...this.state.chart, lockedDate: null } });
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  render() {
    const {
      name,
      id,
      createdBy,
      createdDate,
      lastUpdate,
      privacy,
      useLatestDataAvailable,
      canEdit,
      canArchiveChart,
      category,
      office,
      kpiData,
      benchmarkData,
      isArchived,
      isFavorite,
      rawData,
      yRange,
      benchmarkArray,
      user,
      chart,
    } = this.props;
    // console.log(this.props, chart)
    let { profile } = user;
    let { staticHierarchy } = profile.organizationId;
    let { yAxisFormat } = chart.yAxisFormat;
    let yTickFormat;

    if (yAxisFormat === "Absolute") {
      yTickFormat = ".3%";
    } else {
      yTickFormat = "";
    }
    // console.log(yAxisFormat, yTickFormat)
    // console.log(this.props, '-----chart state and props-----' ,this.state)
    let plotlyData = [];
    let {
      showArchiveConfirmationModal,
      showUnarchiveConfirmationModal,
      dashboardOptions,
      attachedDashboards,
      selectedDashboard,
      showViewChart,
      isGroupModal,
      showManualEntryAnswersModal,
      clickedPoint,
      plotlyDTick,
      isOnDashboard,
      isDashboardModal,
      allOptions,
      showDashboardUrl,
      testOptions,
    } = this.state;
    plotlyData.concat(benchmarkArray);
    if (kpiData) {
      plotlyData = plotlyData.concat(kpiData);
    }
    // if(benchmarkData) {
    //   plotlyData = plotlyData.concat(benchmarkData);
    // }

    // console.log(chart._id,'-----kpiData --- ', kpiData)

    let plotlyKpiData =
      plotlyData && plotlyData.length > 0
        ? plotlyData.filter(
            data =>
              data.name !== "Benchmark for KPI" &&
              data.x &&
              data.x.length > 0 &&
              data.y &&
              data.y.length > 0
          )
        : [];

    // console.log(chart._id,'----plotlyKpiData---- ', plotlyKpiData)
    let plotlyBenchMarkData = plotlyData.filter(
      data => data.name === "Benchmark for KPI"
    );
    let combinedPlotlyData = [...plotlyKpiData, ...plotlyBenchMarkData];

    //Handle single month on x-axis on single kpi point
    let tickvalsString = null;
    if (combinedPlotlyData.length === 1) {
      if (combinedPlotlyData[0].x.length === 1) {
        tickvalsString = [combinedPlotlyData[0].x[0]];
      }
    }

    if (combinedPlotlyData.length > 1) {
      let tickvalsList = combinedPlotlyData.map(data => {
        let xvalues = data.x;
        return xvalues;
      });

      let filteredTickvalsList = tickvalsList.filter(
        tickValue => tickValue.length === 1
      );

      if (
        tickvalsString == null &&
        tickvalsList.length > 0 &&
        tickvalsList.length === filteredTickvalsList.length
      ) {
        let firstTickVal = filteredTickvalsList[0][0];
        let filterTickVal = filteredTickvalsList.filter(tickVal =>
          moment(tickVal[0]).isSame(firstTickVal, "month")
        );
        if (filterTickVal.length === filteredTickvalsList.length) {
          tickvalsString = [firstTickVal];
        }
      }
    }

    let officeNodeCheck = selectOfficeCheck(chart);
    let officeNode = findNodeinHierarchy(
      staticHierarchy,
      officeNodeCheck ? chart.selectedOffice.value : false,
      officeNodeCheck === false ? chart.officeId : false
    );

    let officeName = officeNode.title;

    let yLegend;
    let length = plotlyData.length;
    // -0.7
    if (length < 3) {
      yLegend = -0.5;
    } else if (length > 2 && length < 6) {
      yLegend = -0.5;
    } else if (length > 5 && length < 9) {
      yLegend = -0.7;
    } else if (length > 8 && length < 11) {
      yLegend = -0.9;
    } else if (length > 10) {
      yLegend = -1.2;
    }

    let chartSelector = "_id" + chart._id;

    return (
      <div style={{ padding: "18px 20px", paddingBottom: "15px" }}>
        <div>
          <Dropdown
            isOpen={this.state.dropdownOpen}
            toggle={this.toggle}
            style={{ float: "right" }}
          >
            <DropdownToggle
              tag="span"
              className="chart-item-menu"
              onClick={this.toggle}
              data-toggle="dropdown"
              aria-expanded={this.state.dropdownOpen}
            >
              <i
                className="chart-item-menu flaticon-menu-1"
                style={{ cursor: "pointer" }}
              ></i>
            </DropdownToggle>

            <DropdownMenu
              right
              className="chart-dropdown"
              style={{ padding: "0" }}
            >
              <div
                className="chart-list-dropdown-options"
                onClick={() => this.navigateToChart(chart)}
              >
                <i className="chart-item-menu flaticon-vision" />
                <span className="chart-list-dropdown-options-text">
                  View Chart
                </span>
              </div>

              {officeNode &&
              !officeNode.isRemoved &&
              !this.state.chart.lockedDate ? (
                <If
                  condition={
                    user.profile.orgAdmin || user.profile.role === "Admin"
                  }
                >
                  <div
                    className="chart-list-dropdown-options"
                    onClick={() => this.refreshChart()}
                  >
                    <i className="chart-item-menu flaticon-refresh"></i>
                    <span className="chart-list-dropdown-options-text">
                      Refresh
                    </span>
                  </div>
                </If>
              ) : null}

              <div
                className="chart-list-dropdown-options"
                onClick={() => {
                  this.toggle();
                  this.props.onAddToFavorite(id, isFavorite);
                }}
              >
                <i className="chart-item-menu flaticon-heart"></i>
                <span className="chart-list-dropdown-options-text">
                  {category === "favorites" || isFavorite ? (
                    <span>Remove from favorites</span>
                  ) : (
                    <span>Add to Favorites</span>
                  )}
                </span>
              </div>

              <div
                className="chart-list-dropdown-options"
                onClick={() => this.isDashboardChart()}
              >
                {isOnDashboard ? (
                  <span className="flaticon-check"></span>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className=""
                    viewBox="0 0 16 16"
                  >
                    <path d="M4 11a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0v-1zm6-4a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0V7zM7 9a1 1 0 0 1 2 0v3a1 1 0 1 1-2 0V9z" />
                    <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
                    <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
                  </svg>
                )}
                <span className="chart-list-dropdown-options-text">
                  Add to dashboard
                </span>
              </div>

              <div
                className="chart-list-dropdown-options"
                onClick={() => this.setState({ isGroupModal: true })}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002a.274.274 0 0 1-.014.002H7.022zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816zM4.92 10A5.493 5.493 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275zM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"></path>
                </svg>

                {/* <img src={communityIcon} className="chart_list_group_icon"/>  */}
                <span className="chart-list-dropdown-options-text">
                  Add to Group
                </span>
              </div>

              {officeNode && !officeNode.isRemoved ? (
                <div
                  className="chart-list-dropdown-options"
                  style={{ display: canEdit ? "flex" : "none" }}
                  onClick={this.handleEdit}
                >
                  <i className="chart-item-menu flaticon-edit"></i>
                  <span className="chart-list-dropdown-options-text">Edit</span>
                </div>
              ) : null}

              <div
                className="chart-list-dropdown-options"
                style={{ display: canArchiveChart ? "flex" : "none" }}
                onClick={this.handleArchive}
              >
                <i
                  className={
                    category === "archive" || isArchived
                      ? "chart-item-menu flaticon-update"
                      : "chart-item-menu flaticon-trash"
                  }
                ></i>
                <span className="chart-list-dropdown-options-text">
                  {category === "archive" || isArchived ? `Restore` : `Archive`}
                </span>
              </div>
            </DropdownMenu>
          </Dropdown>

          {/* chart name */}
          <span className="chart-name" data-tip={name}>
            {name}
          </span>

          <ReactTooltip />
          {privacy === chartPrivacy.private ? (
            <img
              style={{
                height: "20px",
                marginBottom: "18px",
                marginLeft: "12px",
              }}
              src={lockIcon}
            />
          ) : privacy === chartPrivacy.office ? (
            <img
              style={{
                height: "20px",
                marginBottom: "18px",
                marginLeft: "12px",
                marginTop: "-10px",
              }}
              src={privacyIcon}
            />
          ) : (
            <img
              style={{
                height: "20px",
                marginBottom: "18px",
                marginLeft: "12px",
              }}
              src={privacyOfficesBelowIcon}
            />
          )}
          {isArchived ? <span className="archived-tag">Archived</span> : null
          // favoritedIcon
          }

          {category === "favorites" || isFavorite ? (
            <img
              style={{
                height: "20px",
                marginBottom: "18px",
                marginLeft: "12px",
              }}
              src={favoritedIcon}
            />
          ) : null}
          {chart.isChartUpdated ? (
            <span className="updatedChart"> Updated </span>
          ) : null}

          {/* <LockUnlockChartComponent
            chart={this.state.chart}
            updateChart={(data)=>{
              this.setState({chart:{...data}})
            }}
            user={user}
          /> */}

          {officeNode && !officeNode.isRemoved ? (
            <span>
              <If
                condition={
                  user.profile.orgAdmin || user.profile.role === "Admin"
                }
              >
                {
                  <span
                    onClick={() => this.props.onRecreate(id)}
                    className="btn-copy"
                  >
                    Copy
                  </span>
                }
              </If>
              <span
                onClick={() => this.props.onChartClick(chart, officeName)}
                className="btn-engage"
              >
                Engage
              </span>
              <div className="chartHamburgerMenu">
                <OoPopover
                  target={chartSelector + "_toprightmenu"}
                  placement="right"
                  headerText="Chart Menu"
                  bodyText={`Top right: Engage, Copy and other options under the hamburger menu. ENGAGE activates Dani (the elephant) which 
                enables you to drill down on a chart and/or provide recommendations for the chart category. COPY copies the KPIs. The hamburger icon (far right at the top)
                includes options to Refresh, Edit, Archive/Restore, or Add to Favorite.`}
                />
              </div>
            </span>
          ) : (
            <span className="alignTop officeRemovedMsg">
              {" "}
              {hierarchyChangeNotifications.isRemoved}
            </span>
          )}
        </div>
        <div
          className="chart-listing-single-details"
          style={{
            color: "#54555F",
            fontSize: "14px",
            lineHeight: "normal",
            marginLeft: "0px",
            marginTop: "-12px",
            marginBottom: "1.75em",
          }}
        >
          <div>
            {officeNode && !officeNode.isRemoved ? "Office:" : null}{" "}
            {officeName}
          </div>
          <div
            className=""
            style={{ color: "#54555F", fontSize: "14px", marginTop: "5px" }}
          >
            <div className="">
              Created by{" "}
              {createdBy ? `${createdBy.firstName} ${createdBy.lastName}` : " "}
              <span className="user_gender_pronoun_analytics">
                {" "}
                {renderGenderPronoun(createdBy)}
              </span>
              <div>
                Created on{" "}
                {moment(createdDate ? createdDate : null).format("MMM Do YYYY")}
                <span style={{ marginLeft: "10px" }}>
                  <img
                    src={dot}
                    height="5px"
                    width="5px"
                    style={{ marginRight: "10px", marginBottom: "3px" }}
                  />
                  Last updated by
                  {` ${lastUpdate.updatedBy.firstName} ${lastUpdate.updatedBy.lastName} `}
                  on
                  {` ${moment(lastUpdate.dateTime).format("MMM Do YYYY")}`}
                </span>
              </div>
            </div>
          </div>

          <div
            className="col-lg-12 col-md-12"
            style={{
              color: "#54555F",
              fontSize: "14px",
              marginTop: "5px",
              padding: "0px",
            }}
          >
            Timeline: {moment.utc(chart.startDate).format("MMM Do YYYY")} -{" "}
            {chart.useLatestDataAvailable
              ? moment().format("MMM Do YYYY")
              : moment.utc(chart.endDate).format("MMM Do YYYY")}
            <div></div>
          </div>

          <LockUnlockChartComponent
            chart={this.state.chart}
            updateChart={data => {
              this.setState({ chart: { ...data } });
            }}
            isChartList={true}
            user={user}
          />
        </div>

        <div className="plotlyChartOptions">
          <OoPopover
            target={chartSelector + "_plotlychartoptions"}
            placement="right"
            headerText="Chart Options"
            bodyText={`Hover on the chart to reveal interactive chart options such as: download chart as png, zoom in/out, compare data on hover to see all data 
                  points on a specific date, and select shapes to highlight various data. The KPIs below the chart can be selected and/or deselected.
                  Click once to deselect, double click on a single KPI to deselect all other options and double click again to select all KPIs.`}
          />
        </div>

        <div
          className="kpiCharts"
          style={{ backgroundColor: "white" }}
          // onMouseOver={this.handlePlotContainerClick}
          ref={input => {
            this.plotRef = input;
          }}
        >
          {console.log(
            "kkkkkk",
            plotlyData.map((x) => x.marker.color[0])
          )}
          <Plot
            data={plotlyData}
            layout={
              chart.layout
                ? {
                    ...chart.layout,
                    datarevision: 1,
                    annotations: this.state.annotations,
                  }
                : {
                    showlegend: true,
                    autosize: true,
                    pull: [0.8, 0, 0],
                    uirevision: true,
                    legend: chartParams(chart, "legend"),
                    paper_bgcolor: "white",
                    plot_bgcolor: "#e5ecf694",
                    margin: chartParams(chart, "margin"),
                    xaxis: chartParams({ ...chart, plotlyDTick }, "xaxis"),
                    yaxis: chartParams(
                      { ...chart, plotlyDTick, ...this.props.yRange },
                      "yaxis"
                    ),
                    // hovermode:'x',
                    hovermode: "closest",
                    annotations: this.state.annotations,
                  }
            }
            useResizeHandler={true}
            scrollZoom={true}
            // config={{displayModeBar:false}}
            config={chartParams({ ...chart, name, officeName }, "config")}
            className="kpiCharts"
            style={{ width: "100%" }}
            // onUpdate={(figure) => this.onPlotlyUpdate(figure)}
            onClick={this.handleChartPointClick}
            onDoubleClick={this.handleChartPointDoubleClick}
          />
          <div className="ml-5 mr-4 pb-4">
            <ChartAverageTable
              chartSelector={chartSelector}
              kpiForPlotly={this.props.kpiData}
              yAxisFormat={chart.yAxisFormat}
              chart={chart}
            />
          </div>
        </div>
        {/* <div className="legendContainer">{this.showLegendReference(id)}</div> */}

        <Modal isOpen={showViewChart} className="viewSingleChartModal">
          <ViewChart
            showLinkedDashboards={true}
            closeViewChartModal={this.closeViewChartModal}
            chart={chart}
          />
        </Modal>

        <Modal isOpen={isDashboardModal} className="dashboardModalContainer">
          <ModalHeader
            className="dashboardHeader"
            charCode="X"
            toggle={() =>
              this.setState(prevState => ({
                isDashboardModal: false,
                selectedDashboard: null,
                showDashboardUrl: false,
              }))
            }
          >
            <div className="dashboardModalTitle">Add to dashboard</div>
          </ModalHeader>
          <ModalBody>
            {/* <div className="modal-title">
              Archive Chart
            </div> */}
            <div className="modal-content-wrapper">
              Select a dashboard from the dropdown to add this chart to it. Then
              click the Add to dashboard button below.
              <Alert color="info">
                <span className="alert-info-text">
                  <span className="alert-info-icon"></span>
                  <strong>Note</strong> - by adding this chart to a dashboard,
                  all users who have access to the dashboard, will now also have
                  access to this chart.
                </span>
              </Alert>
            </div>

            <Select
              isClearable={false}
              // isOpen={true}
              name="permission-select"
              placeholder={"Select a dashboard"}
              value={selectedDashboard}
              options={dashboardOptions}
              onChange={itm => this.onSelectDashboard(itm)}
              className={"basic-multi-select chartListItemDashboard"}
              classNamePrefix="select"
              valueKey="id"
              labelKey="name"
              getOptionLabel={({ name }) => name}
              getOptionValue={({ id }) => id}
              // isOptionDisabled={m => m.isDisabled ==true}
              // isOptionDisabled={(option) => option.isDisabled }
            />

            {showDashboardUrl ? (
              <span
                className="dashboardListShowUrl"
                onClick={() => this.goToDashboard(selectedDashboard)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className=""
                  viewBox="0 0 16 16"
                >
                  <path d="M4 11a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0v-1zm6-4a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0V7zM7 9a1 1 0 0 1 2 0v3a1 1 0 1 1-2 0V9z" />
                  <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
                  <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
                </svg>
                Go to dashboard
              </span>
            ) : null}

            <div className="mt30 dashboardAddChartItemContainer">
              <Button
                color="primary"
                className={
                  selectedDashboard &&
                  this.state.chart.dashboard_array.indexOf(
                    selectedDashboard.id
                  ) == -1
                    ? "dashboardAddChartItem"
                    : "disabledBtn dashboardAddChartItem"
                }
                onClick={
                  selectedDashboard != null &&
                  this.state.chart.dashboard_array.indexOf(
                    selectedDashboard.id
                  ) == -1
                    ? () => this.addToDashboard()
                    : null
                }
              >
                Add to dashboard
              </Button>{" "}
              <Button
                outline
                color="secondary"
                className="dashboardCloseChartItem"
                onClick={() => {
                  this.setState({
                    isDashboardModal: false,
                    selectedDashboard: null,
                    showDashboardUrl: false,
                  });
                }}
              >
                Cancel
              </Button>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={showArchiveConfirmationModal} className="archive-modal">
          <ModalBody>
            <div className="modal-title">Archive Chart</div>
            <div className="modal-content-wrapper">
              You are about to archive the chart <strong>"{chart.name}"</strong>
              . It will only appear in the Archive category of the Analytics
              module.
            </div>
            <div className="modal-note">
              <div style={{ fontSize: "18px", lineHeight: "24px" }}>
                <img
                  src={warningIcon}
                  style={{ width: "20px", marginBottom: "4px" }}
                />
                <span style={{ marginLeft: "15px" }}>Important Note</span>
              </div>
              <div
                style={{
                  fontSize: "16px",
                  marginLeft: "35px",
                  lineHeight: "24px",
                }}
              >
                You will not be able to edit an archived chart. You can restore
                an archived chart by going to the Analytics “Archive” page.
              </div>
            </div>
            <Row className="mt30" style={{ marginLeft: "9px" }}>
              <Col sm={{ size: 4 }} md={{ size: 4 }}>
                <Button
                  className="archive-button"
                  onClick={() => this.archiveChart(id)}
                >
                  Archive Chart
                </Button>{" "}
              </Col>
              <Col sm={{ size: 4 }} md={{ size: 4 }}>
                <Button
                  className="cancel-button"
                  onClick={() => {
                    this.setState(state => ({
                      showArchiveConfirmationModal: !state.showArchiveConfirmationModal,
                    }));
                  }}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={showUnarchiveConfirmationModal}
          className="archive-modal"
        >
          <ModalBody>
            <div className="modal-title">Edit Chart</div>
            <div className="modal-note">
              <div style={{ fontSize: "18px", lineHeight: "24px" }}>
                <img
                  src={warningIcon}
                  style={{ width: "20px", marginBottom: "4px" }}
                />
                <span style={{ marginLeft: "15px" }}>Important Note</span>
              </div>
              <div
                style={{
                  fontSize: "16px",
                  marginLeft: "35px",
                  lineHeight: "24px",
                }}
              >
                You can not edit an archived chart. To edit, first restore the
                chart by clicking on the button below.
              </div>
            </div>
            <Row className="mt30" style={{ marginLeft: "9px" }}>
              <Col sm={{ size: 4 }} md={{ size: 4 }}>
                <Button
                  className="archive-button"
                  onClick={() => this.props.onRestoreChart(id)}
                >
                  Restore Chart
                </Button>{" "}
              </Col>
              <Col sm={{ size: 4 }} md={{ size: 4 }}>
                <Button
                  className="cancel-button"
                  onClick={() => {
                    this.setState(state => ({
                      showUnarchiveConfirmationModal: !state.showUnarchiveConfirmationModal,
                    }));
                  }}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={showManualEntryAnswersModal}
          className="chartListItemModal"
        >
          <ManualEntryModal
            questionAnswer={rawData}
            clickedPoint={clickedPoint}
            toggle={() => {
              this.setState(p => ({
                showManualEntryAnswersModal: !p.showManualEntryAnswersModal,
              }));
            }}
          />
        </Modal>

        {isGroupModal ? (
          <AddToGroup
            closeGroupModal={this.closeGroupModal}
            modelName={"Chart"}
            itemType={chart.category}
            itemId={chart._id}
            item={chart}
            isOpen={isGroupModal}
          />
        ) : null}
      </div>
    );
  }
}

export default ChartListItem;
